module.exports = __webpack_public_path__ + "img/SEJ_Eventos_opciones-21-2.b01834a2.svg";